import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { getUniqueKey, isMobile } from '../../../../utils/HTMLutils'
import Checkbox from '../../../checkbox/Checkbox'
import Row from '../../../row/Row'
import TextEditorHeaderInput from '../textEditorInput/TextEditorHeaderInput'
import TextEditorMenuButton from '../textEditorMenuButton/TextEditorMenuButton'
import './TextEditorUrlCreator.scss'
const rootClassName = 'text-editor-url-creator'

export default function TextEditorUrlCreator(props) {
  const [id] = useState(getUniqueKey())
  const [previousSelection, setPreviousSelection] = useState({})
  const [urlValue, setUrlValue] = useState('')
  const [textValue, setTextValue] = useState('')
  const [newTab, setNewTab] = useState(false)
  const [isUpdating, setUpdating] = useState(false)
  useEffect(() => {
    if (props.opened) {
      const selection = window.getSelection()
      const { anchorNode, anchorOffset, focusNode, focusOffset } = selection
      setPreviousSelection({ anchorNode, anchorOffset, focusNode, focusOffset })
      if (window.getSelection().toString().length) {
        setTextValue(window.getSelection().toString())
      }
      let aux = selection.anchorNode.parentElement
      while (!aux.hasAttribute('id', props.editorId)) {
        if (aux.tagName === 'A') {
          setUrlValue(aux.getAttribute('href'))
          setNewTab(aux.getAttribute('target') === '_blank')
          setUpdating(true)
          break
        }
        aux = aux.parentElement
      }
      /**
       * let isLink = false
       * if (!selection || !selection.anchorNode) return
       * // let fontCount = 0
       * while (!aux.hasAttribute('class', `${rootClassName}-editor`)) {
       *   if (aux.tagName === 'A') {
       *     isLink = true
       *   }
       * }
       */

      // if (!window.getSelection().toString().length) {
      //   // DO NOTHING
      // } else if (anchorNode.parentElement.tagName === 'A') {
      //
      // } else if (
      //   anchorNode.parentElement !== focusNode.parentElement &&
      //   focusNode.parentElement.tagName === 'A'
      // ) {
      //   setUrlValue(focusNode.parentElement.getAttribute('href'))
      //   setNewTab(focusNode.parentElement.getAttribute('target') === '_blank')
      //   setUpdating(true)
      // }
      const el = document.querySelector(`#${id} input`)
      if (el) {
        el.focus()
        if (isMobile()) {
          el.blur()
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.opened])

  const handleSubmit = () => {
    if (!urlValue || !textValue) return
    window
      .getSelection()
      .setBaseAndExtent(
        previousSelection.anchorNode,
        previousSelection.anchorOffset,
        previousSelection.focusNode,
        previousSelection.focusOffset
      )
    props.onChange(textValue, urlValue, newTab)
  }

  return (
    <div id={id} className={rootClassName}>
      <Row className={`${rootClassName}-url-row`}>
        <TextEditorHeaderInput
          label='Url'
          value={urlValue}
          onChange={(evt) => setUrlValue(evt.target.value)}
          onEnter={handleSubmit}
        />
      </Row>
      <Row className={`${rootClassName}-text-row`}>
        <TextEditorHeaderInput
          label='Texto'
          value={textValue}
          onChange={(evt) => setTextValue(evt.target.value)}
          onEnter={handleSubmit}
        />
      </Row>
      <Row className={`${rootClassName}-new-tab-row`}>
        <Checkbox value={newTab} onChange={(value) => setNewTab(value)} />
        <span onClick={() => setNewTab(!newTab)}>Nova Guia</span>
      </Row>
      <Row className={`${rootClassName}-ok-row`}>
        <TextEditorMenuButton
          disabled={!urlValue || !textValue}
          onClick={handleSubmit}
        >
          {isUpdating ? 'Atualizar' : 'OK'}
        </TextEditorMenuButton>
      </Row>
    </div>
  )
}

TextEditorUrlCreator.propTypes = {
  opened: PropTypes.bool,
  onChange: PropTypes.func,
  editorId: PropTypes.string
}

TextEditorUrlCreator.defaultProps = {
  onChange: () => {}
}
